module.exports = __webpack_public_path__ + "images/electricityab89c74569ba4b4c6a1198d9519c185e.png";